import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { DealFormGroup, DealProductFormGroup } from 'src/pages/admin/trading/deal-form/deal-form-page/deal-form.schema'
import { ModalService } from 'src/shared/modal/modal.service'
import { DealProductOverlayComponent, DealProductOverlayDealViewRaw, DealProductOverlayOptions } from './deal-product-overlay.component'

@Injectable()
export class DealProductOverlayService {
  private modal = inject(ModalService)


  showProductDetails(dealViewRaw$: Observable<DealProductOverlayDealViewRaw>, dealForm: DealFormGroup, productForm: DealProductFormGroup) {
    return this.modal.openLargeSide<DealProductOverlayComponent, DealProductOverlayOptions>(DealProductOverlayComponent, {
      dealViewRaw$, dealForm, productForm,
    })
  }
}
